import { render, staticRenderFns } from "./agricultureDetails.vue?vue&type=template&id=420575da&scoped=true"
import script from "./agricultureDetails.vue?vue&type=script&lang=js"
export * from "./agricultureDetails.vue?vue&type=script&lang=js"
import style0 from "./agricultureDetails.vue?vue&type=style&index=0&id=420575da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420575da",
  null
  
)

export default component.exports